import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/common/services/api.service';
import { ClientService } from 'src/app/client/client.service';

@Injectable({
    providedIn: 'root'
})
export class OfferService {

    public wizard: any = {};
    public clientSearchData: any;
    public clientCode: any;
    public productCode: any;
    public departmentCode: any;
    public processCode: any;
    public versionNo: any;
    public currentStep: any= 1;
    public lastValidatedStep: any = 0;
    public currentView: any = 1;
    public offerHeaderKey: any;
    public selectedOffer: any;
    public errorControls: Array<any> = [];
    public scriptErrorControls: Array<any> = [];

    public clientProcesseCodes: any;
    public clientNewOffer: string;
    public clientNewLead: string;
    public clientNewPolicy: string;
    public clientNewClient: string;
    public clientConsultation: string;
    public clientModification: string;

    public appliedDiscount: any = {};

    requiredControls: Array<string> = [];
    offers: any;
    steps: any;
    control: any;
    referentials: any;
    items: any = [];
    loadingDDLdata: boolean = false;
    

    constructor(private apiService: ApiService,
        private clientService: ClientService) {

        var model = {
            ClientKey: "",
        };

        this.apiService.post("Api/ClientTemplateApi/SearchClientProcesses/", model).subscribe((res) => {
            this.clientProcesseCodes = res;

            this.clientNewOffer = res["CLIENT_NEWOFFER"];
            this.clientNewLead = res["CLIENT_NEWLEAD"];
            this.clientNewPolicy = res["CLIENT_NEWPOLICY"];
            this.clientNewClient = res["CLIENT_NEWCLIENT"];
            this.clientConsultation = res["CLIENT_CONSULTCLIENT"];
            this.clientModification = res["CLIENT_CLIENTMODIFICATION"];

        });
   }

    clearData() {
        this.clientCode = null;
        this.processCode = null;
        this.departmentCode = null;
        this.productCode = null;
        this.versionNo = null;
        this.offerHeaderKey = null;
    }

    //To validate each step controls
    validateControls(controls) {
        for (var controlKey in controls) { //notes: some controls arrays are empty, why?
            var control = controls[controlKey];
            control.hasError = false;

            //required field validation
            if (!this.wizard.IsPolicy) {
                if (control.Properties && control.Properties.OfferVisible && control.Properties.OfferVisible.Value &&
                    control.Properties.OfferRequired && control.Properties.OfferRequired.Value && !control.Value) {
                    
                    this.errorControls.push(control);
                    control.hasError = true;
                }
            }
            else {
                if (control.Properties && control.Properties.PolicyVisible && control.Properties.PolicyVisible.Value) {
                    if (control.Properties.PolicyRequired && control.Properties.PolicyRequired.Value && !control.Value) {
                        this.errorControls.push(control);
                        control.hasError = true;
                    }
                }


                //if (control.Properties  !=null  && control.Properties.PolicyVisible  !=null  && control.Properties.PolicyVisible.Value !=null ) {
                //    if (control.Properties.PolicyRequired && control.Properties.PolicyRequired.Value && control.Value) {
                //        this.errorControls.push(control);
                //        control.hasError = true;
                //this.scriptErrorControls.push(control); //testing
                //    }
                //}


            }

            //script errors for section and cover controls
            //productError: Error raised as result of product genrator script
            //clientError: Error raised as result of client side script
            if (control.productError || control.clientError) {
                control.hasError = true;
                this.scriptErrorControls.push(control);
            }
        }
    }


    validateWizardControls(wizard) {

        this.requiredControls = [];
        for (var stepKey in wizard.Steps) {
            for (var groupKey in wizard.Steps[stepKey].ControlGroups) {
                if (!wizard.Steps[stepKey].ControlGroups[groupKey].IsMultiline) {

                    for (var controlKey in wizard.Steps[stepKey].ControlGroups[groupKey].Controls) {
                        if (wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties.OfferRequired.Value == true &&
                            !wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Value) {
                            this.requiredControls.push(wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Text)
                        }
                    }
                }
                else {
                    for (var controlKey in wizard.Steps[stepKey].ControlGroups[groupKey].Controls) {
                        if (wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties.OfferRequired.Value == true &&
                            wizard.Steps[stepKey].ControlGroups[groupKey].LineCodes.length == 0) {
                            this.requiredControls.push(wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Text)
                        }
                    }
                }
            }
        }

        if (wizard.IsDocument == true) {
            for (var docKey in wizard.Documents) {
                if (wizard.Documents[docKey].IsMandatory &&
                    (wizard.Documents[docKey].Image == null || wizard.Documents[docKey].Image == "")) {
                    this.requiredControls.push(wizard.Documents[docKey].DocumentTypeText)
                }
            }
        }

        return this.requiredControls.length;
    }

   

}